module.exports = __webpack_public_path__ + "img/636-2772b7.png";